// extracted by mini-css-extract-plugin
export var discard = "_4t-3";
export var muiTooltipTooltip = "_4t-5";
export var notificationBar = "_4t-2";
export var saveButtonHoverSlotWrapper = "_4t-4";
export var show = "_4t-1";
export var spacer = "_4t-0";